import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ObserverEmitter, { EVENTS } from "../../../emitter/Observer";
import { imgsTopicSevenActvOne } from "../../../assets/activityes/topicSevenActivityOne";
import { completeOneTask } from "../../../store/slices/menu/tunks";
import { useNavigate } from "react-router-dom";
import { tasksId } from "../../../types/activityTasks";
import { PanelActivities } from "../../../components/common/PanelActivities";
import { ButtonPlay } from "../../../components/common/ButtonPlay";
import { ButtonHome } from "../../../components/common/ButtonHome";
import { useGetActivitiesBySubTopic } from "../../../hooks/useGetActivitiesBySubTopic";
import { DialogBarNew } from "../../../components/common/DialogBarNew";
import { HeaderRedPresentation } from "../../../components/common/HeaderRedPresentation";
import { ValidationResultModal } from "../../../components/common/ValidationResultModal";
import { audiosAssets } from "../../../assets/audio";
import { voicesTypeControl } from "../../../types/audioType";
import { ButtonReturn } from "../../../components/common/ButtonReturn";

const steps = {
	dialogInitial: 1,
	viewActivities: 100,
	dialogTwo: 2,
	dialogThree: 3,
	instructions: 4,
	dialogFour: 5,
	dialogFive: 6,
	dialogSix: 7,
	dialogSeven: 8,
	dialog8: 9,
	dialog9: 10,
	dialog10: 11,
	dialog11: 12,
	dialog12: 13,
	dialog13: 14,
	dialog14: 15,
	dialog15: 16,
	dialog16: 17,
	dialog17: 18,
	dialog18: 19,
	dialog19: 20,
	dialog20: 21,
	dialog21: 22,
};

export const SubtopicSevenActivityTwo = () => {
	const { loaded, activitiesInformation } = useSelector((state) => state.menu);
	const dispatch = useDispatch();
	const navigator = useNavigate();
	const [uiToShow, setUiToShow] = useState(steps.dialogInitial);
	const { tasksList, points } = useGetActivitiesBySubTopic(activitiesInformation[tasksId.tema1.activities.subtema7], 2);


	useEffect(() => {
		if (loaded) {
			ObserverEmitter.emit(EVENTS.subtopicSeven.initScene, 2);
			ObserverEmitter.emit(EVENTS.audiosEvents.pauseActive, true)
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.onOxxoScene)
		}
	}, [loaded]);

	ObserverEmitter.on(EVENTS.audioInitByTopic, () => {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub07.sub7_act2_a01)
	})

	return (
		<>
			<>
				<ButtonPlay />
				<ButtonHome />
				{![1, -1].includes(uiToShow) && (
					<ButtonReturn callback={() => {
						ObserverEmitter.emit(EVENTS.subtopicSeven.initScene, 2);
						setUiToShow(1)
					}} />
				)}
			</>
			{uiToShow === steps.dialogInitial && (
				<>
					<HeaderRedPresentation name="Actividad 2:  Enfoques mensuales." />
					<DialogBarNew
						titulo="Datti Andatti"
						dialog={'Es momento de pasar a un tema importante, las cuales son tus "Responsabilidades Operativas".'}
						percentage={"10%"}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel);
							setUiToShow(steps.viewActivities);
						}}
					></DialogBarNew>
				</>
			)}
			{steps.viewActivities === uiToShow && (
				<>
					<PanelActivities
						buttonText="¡Comenzar!"
						title="Subtema 6: PromOXXO."
						titleActivity="Actividades por realizar:"
						points={points}
						insigniaBackground={0}
						actionButton={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub07.sub7_act2_a02)
							ObserverEmitter.emit(EVENTS.characterAnimations.idle);
							setUiToShow(steps.dialog9);
						}}
						activities={tasksList}
					/>
				</>
			)}

			{uiToShow === steps.dialog9 && (
				<>
					<ContainerImagesTable img={imgsTopicSevenActvOne.screen5}></ContainerImagesTable>
					<DialogBarNew
						titulo="Datti Andatti"
						dialog={`Para comenzar selecciona Excelencia Operativa.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub07.sub7_act2_a03)
							setUiToShow(steps.dialog10);
						}}
						percentage={"50%"}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.dialog10 && (
				<>
					<ContainerImagesTable img={imgsTopicSevenActvOne.screen6}></ContainerImagesTable>
					<DialogBarNew
						titulo="Datti Andatti"
						dialog={`Se seleccionara el Cuadernillo de Responsabilidades.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub07.sub7_act2_a04)
							setUiToShow(steps.dialog11);
						}}
						percentage={"55%"}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.dialog11 && (
				<>
					<ContainerImagesTable img={imgsTopicSevenActvOne.screen7}></ContainerImagesTable>
					<DialogBarNew
						titulo="Datti Andatti"
						dialog={`En el, deberás de ubicar el apartado de “Enfoque Mensual”.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub07.sub7_act2_a05)
							setUiToShow(steps.dialog12);
						}}
						percentage={"60%"}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.dialog12 && (
				<>
					<ContainerImagesTable img={imgsTopicSevenActvOne.screen8}></ContainerImagesTable>
					<DialogBarNew
						titulo="Datti Andatti"
						dialog={`¡Bien! Podrás ver todos los enfoques que corresponden al mes actual, editar, agregar y eliminarlos, si deseas agregar uno selecciona el botón de Nuevo.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub07.sub7_act2_a06)
							setUiToShow(steps.dialog13);
						}}
						percentage={"65%"}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.dialog13 && (
				<>
					<ContainerImagesTable img={imgsTopicSevenActvOne.screen9}></ContainerImagesTable>

					<DialogBarNew
						titulo="Datti Andatti"
						dialog={`Aquí podrás ingresar información valiosa para tu nuevo enfoque mensual.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub07.sub7_act2_a07)
							setUiToShow(steps.dialog14);
						}}
						percentage={"70%"}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.dialog14 && (
				<>
					<ContainerImagesTable img={imgsTopicSevenActvOne.screen10}></ContainerImagesTable>

					<DialogBarNew
						titulo="Datti Andatti"
						dialog={`Por último, es momento de saber sobre el Listado de pendientes. Para explorar sus opciones, deberás seleccionar Excelencia Operativa.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub07.sub7_act2_a08)
							setUiToShow(steps.dialog15);
						}}
						percentage={"75%"}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.dialog15 && (
				<>
					<ContainerImagesTable img={imgsTopicSevenActvOne.screen11}></ContainerImagesTable>
					<DialogBarNew
						titulo="Datti Andatti"
						dialog={`Se seleccionará el Cuadernillo de Responsabilidades.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub07.sub7_act2_a09)
							setUiToShow(steps.dialog16);
						}}
						percentage={"80%"}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.dialog16 && (
				<>
					<ContainerImagesTable img={imgsTopicSevenActvOne.screen12}></ContainerImagesTable>
					<DialogBarNew
						titulo="Datti Andatti"
						dialog={`En el, deberás de ubicar el apartado de “Listado de Pendientes Líder”.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub07.sub7_act2_a10)
							setUiToShow(steps.dialog17);
						}}
						percentage={"85%"}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.dialog17 && (
				<>
					<ContainerImagesTable img={imgsTopicSevenActvOne.screen13}></ContainerImagesTable>
					<DialogBarNew
						titulo="Datti Andatti"
						dialog={`Mira todos los pendientes que tenemos activos, estos indican las actividades que se deben de hacer de manera ordenada. Si deseas agregar uno, selecciona el botón de Agregar.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub07.sub7_act2_a11)
							setUiToShow(steps.dialog18);
						}}
						percentage={"90%"}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.dialog18 && (
				<>
					<ContainerImagesTable img={imgsTopicSevenActvOne.screen14}></ContainerImagesTable>
					<DialogBarNew
						titulo="Datti Andatti"
						dialog={`En esta sección se realizará el registro de tareas que se hayan completado.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub07.sub7_act2_a12)
							setUiToShow(steps.dialog19);
						}}
						percentage={"95%"}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.dialog19 && (
				<>
					<ContainerImagesTable img={imgsTopicSevenActvOne.screen15}></ContainerImagesTable>
					<DialogBarNew
						titulo="Datti Andatti"
						dialog={`Listo, tendrás activo en la semana tu actividad y estará en el listado de pendientes.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							setUiToShow(steps.dialog8);
						}}
						percentage={"100%"}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.dialog8 && (
				<>
					<ValidationResultModal
						title="¡Bien hecho!"
						dialogModal="Recuerda que llegar a las metas es de suma importancia para nuestra Tienda OXXO."
						buttonTxt="Continuar"
						isCorrect={true}
						action={() => {
							dispatch(
								completeOneTask({
									idActivity: 2,
									pointsWin: 0,
									subtema: tasksId.tema1.activities.subtema7,
								})
							);
							navigator("/home1/tema1/subtema7/activityresult");
						}}
					/>
				</>
			)}
		</>
	);
};


const ContainerImagesTable = ({ img = "", callback = () => { }, children }) => {
	return (
		<>
			<div className="fixed z-30 h-full w-full flex justify-center items-center">
				<div className="w-[433px] h-[238px] md:w-[880px] md:h-[484px]">
					<div className="h-full w-full">
						<img className="h-full w-full object-contain" src={img} alt="images" />
					</div>
				</div>
				{children}
			</div>
		</>
	)
}